export const formatDate = (dateStr: string) => {
  try {
    // We're getting dates in YYYY-MM-DD format from the store
    const date = new Date(dateStr + 'T00:00:00'); // Add time to ensure consistent timezone handling
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateStr);
      return 'Invalid date';
    }

    // Format using Intl.DateTimeFormat for consistent localization
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC' // Use UTC to avoid timezone issues
    }).format(date);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};
